import { Dataset, DatasetControl } from '../../types/types';

// All app controls matching the query identity (name ?? label) in the given datasets.
export const findExternalAppControls = (
  controlId: string | null,
  datasets: (Dataset | undefined)[]
): DatasetControl[] => {
  if (!controlId) {
    return [];
  }

  return datasets.flatMap(
    (dataset) =>
      dataset?.controls?.filter(
        (control) =>
          (control.name ?? control.label) === controlId &&
          control.action?.type === 'app'
      ) ?? []
  );
};
